import {
  Paper,
  Checkbox,
  Button,
  Dialog,
  DialogContent,
  TextField,
  DialogActions,
  Grid,
  DialogTitle,
  CircularProgress,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import React, { useState, useEffect } from "react";
import api from "../../components/services/api";
import Swal from "sweetalert2";

import withReactContent from "sweetalert2-react-content";
// import DialogForAPI from "../../Component/DialogForAPI.js";
import "./css/styles.css";

const drawerHeight = "100%";
const drawerwidth = "100%";
const useStyles = makeStyles((theme) => ({
  root: {
    height: drawerHeight,
    width: drawerwidth,
    marginTop: 20,
  },
  Padding: {
    paddingTop: "2%",
    paddingRight: "6%",
    paddingLeft: "6%",
    paddingBottom: "2%",
  },
}));
export default function SetPermissions() {
  const classes = useStyles();
  const EmpId = localStorage.getItem("EmpId");
  const [MenuList, setMenuList] = useState([]);
  const [SubMenuList, setSubMenuList] = useState([]);
  const [SubMenuNo, setSubMenuNo] = useState("");
  const [MenuNo, setMenuNo] = useState("");
  const [ActionList, setActionList] = useState([]);
  const [Name, setName] = useState("");
  const [OpenEdit, setOpenEdit] = useState(false);
  // const [open, setOpen] = useState(false);
  const [Status, setStatus] = useState("Y");
  // const [message, setmessage] = useState("");
  const [openCancel, setOpenCancel] = useState(false);
  const [ActionNo, setActionNo] = useState("");
  const [Loading, setLoading] = useState(false);
  const [RoleList, setRoleList] = useState([]);
  const [detail, setDetail] = useState([]);
  // const [ActionRole, setActionRole] = useState([]);
  // const [isShow, setIsShow] = useState(false);

  const fetchRoleList = async () => {
    try {
      const result = await api.get("api/role/list");
      const _result = result.data.map((x) => ({
        ...x,
        selected: false,
      }));
      // const _result = result.data;
      // console.log(_result);
      setRoleList(_result);
    } catch (error) {
      console.log("error => ", error);
    }
  };

  const fetchActionRole = async (Data) => {
    try {
      const data = {
        actionNo: Data,
      };
      const result = await api.post("/api/config/action", data);
      const _result = result.data;
      // setActionRole(_result);
      // console.log(ActionRole);
      // setSelectedRole();

      const roles = _result.filter((x) => x.ActionNo === ActionNo);

      const roleIds = roles.map((x) => x.Role);
      // console.log(roleIds);

      const roleList = [...RoleList]; // clone deep
      // RoleList[0].selected = 0

      for (let r of roleList) {
        // console.log(typeof parseInt(r.RoleId));
        // console.log(roleIds);
        // console.log(r);
        // console.log(roleIds.indexOf(parseInt(r.RoleId)));
        // r.selected = roleIds.indexOf(parseInt(r.RoleId)) > -1 ? true : false;
        r.selected = roleIds.indexOf(r.RoleId) > -1 ? true : false;
      }
      // console.log([...roleList]);

      setRoleList([...roleList]);

      // console.log(_result);
    } catch (error) {
      console.log("error => ", error);
    }
    // try {
    //   const result = await api.get("api/setting/actions/role");
    //   const _result = result.data.results;
    //   setActionRole(_result);
    //   // CheckBoxIsTrue(_result);
    // } catch (error) {
    //   console.log("error => ", error);
    // }
  };

  const fetchMenuAll = async () => {
    try {
      const result = await api.get("api/menu/list");
      const _result = result.data;
      setMenuList(_result);
      setActionNo("");
    } catch (error) {
      console.log("error => ", error);
    }
  };

  const fetchActionMenu = async (m_no, sub_m_no) => {
    try {
      const data = {
        menuNo: m_no,
        subMenuNo: sub_m_no,
      };

      const result = await api.post("api/actionmenu/list", data);
      const _result = result.data;
      setActionList(_result);
    } catch (error) {
      console.log("error => ", error);
    }
  };

  const EditAndAddAction = async () => {
    const body = {
      MenuNo: MenuNo,
      SubMenuNo: SubMenuNo,
      ActionNo: ActionNo,
      ActionName: Name,
      Status: Status,
    };

    try {
     await api
        .post("api/setting/actionmenu/add", body)
        .then((res) => {
          if (res) {
            // setOpen(true);
            // setmessage(res.data.message);
            setTimeout(() => {
              handleClose();
              // setOpen(false);
            }, 2000);
            fetchActionMenu();
          }
        });
    } catch (error) {
      console.log("error => ", error);
    }
  };

  const saveRole = async () => {
    setLoading(true);
    const setDetail = detail.map((x, index) => ({
      roleId: x.RoleId,
      menuNo: MenuNo,
      subMenuNo: SubMenuNo,
      actionNo: ActionNo,
      status: x.selected === true ? "1" : "0",
      createId: EmpId,
    }));

    const body = { detail: setDetail };

    try {
       await api
        .post("api/config/update", body.detail)
        .then((res) => {
          // if (res) {
          //   // setOpen(true);
          //   // setmessage(res.data.message);
          //   // setTimeout(() => {
          //   //   // handleCloseDialog();
          //   //   // setOpen(false);

          //   //   window.location.reload(false);
          //   // }, 500);
          //   // fetchActionRole();

          // }
          // console.log(res);
          const MySwal = withReactContent(Swal);
          MySwal.fire({
            icon: "success",
            didOpen: () => {
              MySwal.clickConfirm();
            },
          }).then(() => {
            return MySwal.fire(
              "สำเร็จ!",
              "แก้ไขสิทธิ์สำเร็จ !",
              "success"
            ).then((result) => {
              if (result.isConfirmed) {
              }
            });
          });
          // console.log(result);
          setLoading(false);
        });
    } catch (error) {
      console.log("error => ", error);
      setLoading(false);
    }
  };

  // const setSelectedRole = () => {
  //   const roles = ActionRole.filter((x) => x.ActionNo === ActionNo);
  //   const roleIds = roles.map((x) => x.role);

  //   const roleList = [...RoleList]; // clone deep
  //   // RoleList[0].selected = 0

  //   for (let r of roleList) {
  //     r.selected = roleIds.indexOf(r.roleId) > -1 ? true : false;
  //   }

  //   setRoleList([...roleList]);

  //   // setRoleList(RoleList.map((x) => ({ ...x, selected: true })));
  // };

  const fetchSubmenuList = async (Data) => {
    setMenuNo(Data.MenuNo);
    setSubMenuNo(Data.SubMenuNo);
    const data = {
      menuNo: Data,
    };

    try {
      const result = await api.post("api/submenu/list", data);
      // console.log(result.data);
      const _result = result.data;
      setSubMenuList(_result);
      fetchActionMenu();
    } catch (error) {
      console.log("error => ", error);
    }
  };

  useEffect(() => {
    async function fetchData() {
      await fetchMenuAll();
      // await fetchActionRole();
      if (MenuNo || SubMenuNo) {
        await fetchActionMenu(MenuNo, SubMenuNo);
      }
    }
    fetchData();
  }, [SubMenuNo, MenuNo]);

  useEffect(() => {
    async function fetchData() {
      await fetchActionRole(ActionNo);
      // if (ActionNo) {
      //   await setSelectedRole();
      // }
    }
    fetchData();
  }, [ActionNo]);

  useEffect(() => {
    async function fetchData() {}
    fetchRoleList();
    fetchData();
  }, []);

  useEffect(() => {
    fetchMenuAll();
  }, []);

  const handleClose = () => {
    // setOpen(false);
    setOpenEdit(false);
    setOpenCancel(false);
    setName("");
    setMenuNo("");
    setSubMenuNo("");
    setStatus("Y");
    setLoading(false);
  };

  // const handleCloseDialog = (props) => {
  //   setOpen(props);
  // };

  const handleSaveEditAction = () => {
    const selectedAction = ActionList.filter((x) => x.actionNo === ActionNo);

    selectedAction.forEach((x) => {
      x.actionName = Name;
    });

    setActionList([...ActionList]);

    EditAndAddAction();
  };

  // const handleCancelAction = (ActionSelect) => {
  //   //need Data
  //   setMenuNo(MenuNo);
  //   setSubMenuNo(ActionSelect.subMenuNo);
  //   setActionNo(ActionSelect.actionNo);
  //   setStatus("N");

  //   setOpenCancel(true);
  // };

  // const handleEditAndAddAction = (Data) => {
  //   //need Data
  //   setMenuNo(MenuNo);
  //   setSubMenuNo(Data.subMenuNo);
  //   setName(Data.actionName);
  //   setActionNo(Data.actionNo);
  //   setOpenEdit(true);
  // };

  const handleClickSubForAction = (Data) => {
    setMenuNo(Data.MenuNo);
    setSubMenuNo(Data.SubMenuNo);
    fetchActionMenu(Data.MenuNo, Data.SubMenuNo);
  };

  const handleCheckBox = (role, index, checked) => {
    const _roleList = RoleList.map((item, index2) =>
      index === index2 ? { ...item, selected: checked } : item
    );

    // console.log(_roleList);

    setRoleList(_roleList);
    setDetail(_roleList);
  };

  return (
    <div className={classes.root}>
      <Paper elevation={1} style={{ height: "88vh", overflow: "auto" }}>
        <div className={classes.Padding}>
          <p style={{ color: "#80C340", fontSize: 18 }}>Sritrang-Admin</p>
          <h3>กำหนดสิทธิ์</h3>
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              flexDirection: "row",
              marginBottom: 30,
              position: "sticky",
              top: 10,
            }}
          >
            <Button
              variant="contained"
              size="large"
              style={{
                color: "white",
                backgroundColor: "#80C340",
                borderColor: "transparent",
                marginLeft: 10,
                width: 120,
                textTransform: "lowercase",
              }}
              onClick={() => saveRole()}
            >
              {Loading ? (
                <CircularProgress
                  sx={{
                    color: "#FFFFFF",
                  }}
                  size={24}
                />
              ) : (
                "บันทึก"
              )}
            </Button>
          </div>
          <Grid container spacing={5}>
            <Grid item xs={4}>
              <p style={{ color: "#30318D" }}>Category</p>
              <div
              // style={{ maxHeight: "58vh", height: "100%", overflow: "auto" }}
              >
                <table style={{ width: "100%", maxWidth: "100%" }}>
                  {MenuList.map((Data, index) => (
                    <tbody>
                      <tr key={index}>
                        <td
                          style={{
                            display: "flex",
                            border: "1px solid #ffffff",
                            backgroundColor: "#E9E9E9",
                            borderRadius: "5px",
                            flexWrap: "wrap",
                          }}
                          onClick={() => {
                            fetchSubmenuList(Data.MenuNo);
                            setMenuNo(Data.MenuNo);
                            setSubMenuNo("");
                          }}
                        >
                          <span
                            style={{
                              margin: "5px 0px 5px 5px",
                            }}
                          >
                            {Data.MenuName}
                          </span>
                        </td>
                        {SubMenuList.filter(
                          (x) => x.MenuNo === Data.MenuNo
                        ).map((sub) => (
                          <td
                            className="table-list-group-item-action"
                            style={
                              sub.SubMenuNo === SubMenuNo
                                ? {
                                    display: "flex",
                                    border: "1px solid #e0e0e0",
                                    backgroundColor: "#e7e7e7",
                                    borderRadius: "5px",
                                  }
                                : {
                                    display: "flex",
                                    border: "1px solid #e0e0e0",
                                    // backgroundColor: "#FAFBFD",
                                    borderRadius: "5px",
                                  }
                            }
                            onClick={() => handleClickSubForAction(sub)}
                          >
                            <span style={{ margin: "5px 0px 5px 20px" }}>
                              {sub.SubMenuName}
                            </span>
                          </td>
                        ))}
                      </tr>
                    </tbody>
                  ))}
                </table>
              </div>
            </Grid>

            <Grid item xs={4}>
              <div
                style={{
                  maxHeight: "58vh",
                  height: "100%",
                  position: "sticky",
                  top: 10,
                  width: "100%",
                }}
              >
                <p style={{ color: "#30318D" }}>Action</p>
                <table style={{ width: "100%", maxWidth: "100%" }}>
                  {ActionList?.map((Data, index) => (
                    <tbody>
                      <tr>
                        <td
                          className="table-list-group-item-action"
                          key={Data.ActionId}
                          style={{
                            display: "flex",
                            border: "1px solid #e0e0e0",
                            borderRadius: "5px",
                            flexWrap: "wrap",
                          }}
                          onClick={() => {
                            setActionNo(Data.ActionNo);
                            // setIsShow(true);
                          }}
                        >
                          <span
                            style={{
                              margin: "5px 0px 5px 5px",
                            }}
                          >
                            [{Data.ActionNo}]<span>&nbsp;</span>
                            {Data.ActionName}
                          </span>
                        </td>
                      </tr>
                    </tbody>
                  ))}
                </table>
              </div>
            </Grid>

            <Grid item xs={4}>
              <div
                style={{
                  maxHeight: "58vh",
                  height: "100%",
                  position: "sticky",
                  top: 10,
                  width: "100%",
                }}
              >
                <p style={{ color: "#30318D" }}>Role</p>
                <table style={{ width: "100%", maxWidth: "100%" }}>
                  {ActionNo &&
                    RoleList.map((Data, index) => (
                      <tbody>
                        <tr>
                          <td
                            key={index}
                            style={{
                              display: "flex",
                              border: "1px solid #e0e0e0",
                              flexWrap: "wrap",
                            }}
                            // onClick={() => setActionNo(Data.actionNo)}
                          >
                            <Checkbox
                              size="small"
                              sx={{
                                color: "#30318D",
                                "&.Mui-checked": {
                                  color: "#30318D",
                                },
                              }}
                              id={"Role" + index}
                              name={"Role" + index}
                              onChange={(e) =>
                                handleCheckBox(Data, index, e.target.checked)
                              }
                              checked={Data?.selected || false}
                            />
                            <span
                              style={{
                                margin: "5px 0px 5px 5px",
                              }}
                            >
                              {Data.RoleName}
                            </span>
                          </td>
                        </tr>
                      </tbody>
                    ))}
                </table>
              </div>
            </Grid>
          </Grid>

          <Dialog
            open={OpenEdit}
            onClose={() => handleClose()}
            fullWidth={true}
            maxWidth="xs"
            classes={{ paper: classes.dialogPaper }}
          >
            <DialogContent>
              <TextField
                sx={{ width: "100%" }}
                size="small"
                onChange={(e) => setName(e.target.value)}
                value={Name}
                required
                // error={ExcelNameErr}
                label="ชื่อ"
              />
            </DialogContent>
            <DialogActions
              style={{
                display: "flex",
                justifyContent: "center",
                marginBottom: 20,
              }}
            >
              <Button
                variant="contained"
                style={{
                  color: "black",
                  borderColor: "transparent",
                  backgroundColor: "#F8F9FA",
                  padding: 10,
                  marginRight: 10,
                  width: 80,
                }}
                onClick={() => handleClose()}
              >
                ยกเลิก
              </Button>

              <Button
                variant="contained"
                style={{
                  color: "white",
                  backgroundColor: "#FF0000",
                  borderColor: "transparent",
                  padding: 10,
                  marginRight: 10,
                  width: 80,
                }}
                onClick={() => handleSaveEditAction()}
              >
                {Loading ? (
                  <CircularProgress
                    sx={{
                      color: "#FFFFFF",
                    }}
                    size={24}
                  />
                ) : (
                  "ตกลง"
                )}
              </Button>
            </DialogActions>
          </Dialog>

          <Dialog
            open={openCancel}
            onClose={() => handleClose()}
            fullWidth={true}
            maxWidth="xs"
            classes={{ paper: classes.dialogPaper }}
          >
            <DialogTitle>ยืนยันที่จะลบหรือไม่</DialogTitle>
            <DialogActions
              style={{
                display: "flex",
                justifyContent: "center",
                marginBottom: 20,
              }}
            >
              <Button
                variant="contained"
                style={{
                  color: "black",
                  borderColor: "transparent",
                  backgroundColor: "#F8F9FA",
                  padding: 10,
                  marginRight: 10,
                  width: 80,
                }}
                onClick={() => handleClose()}
              >
                ยกเลิก
              </Button>
              <Button
                variant="contained"
                style={{
                  color: "white",
                  backgroundColor: "#FF0000",
                  borderColor: "transparent",
                  padding: 10,
                  marginRight: 10,
                  width: 80,
                }}
                onClick={() => EditAndAddAction("del")}
              >
                {Loading ? (
                  <CircularProgress
                    sx={{
                      color: "#FFFFFF",
                    }}
                    size={24}
                  />
                ) : (
                  "ตกลง"
                )}
              </Button>
            </DialogActions>
          </Dialog>

          {/* <DialogForAPI
            DialogOpen={open}
            DialogClose={handleCloseDialog}
            message={message}
          /> */}
        </div>
      </Paper>
    </div>
  );
}
